import { useState } from 'react';
import { StickyNote } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { supabase } from '@/lib/supabase';

export function QuickNote() {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    if (!note.trim()) return;
    setSaving(true);
    setSaved(false);
    const { error } = await supabase.from('personal_note').insert({ content: note } as never);
    setSaving(false);
    if (!error) {
      setNote('');
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    }
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <StickyNote className="h-4 w-4" />
          Quick Note
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Textarea
          placeholder="Jot something down..."
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="resize-none"
        />
        <div className="mt-2 flex items-center justify-between">
          {saved && <span className="text-xs text-green-600">Saved!</span>}
          {!saved && <span />}
          <Button size="sm" onClick={handleSave} disabled={saving || !note.trim()}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
